import http from '@/services/http-client';
import routes from '@/../config/env';

const { userManagementService } = routes;

export const getUsers = (params) => http({
  method: 'get',
  url: `${userManagementService}/api/admin/users`,
  params,
});

export const getAuditLog = (params) => http({
  method: 'get',
  url: `${userManagementService}/api/admin/audit`,
  params,
});

export const createUser = (payload) => http({
  method: 'post',
  url: `${userManagementService}/api/admin/users`,
  data: payload,
});

export const getUserById = (userId) => http({
  method: 'get',
  url: `${userManagementService}/api/admin/users/${userId}`,
});

export const updateUser = (userId, payload) => http({
  method: 'put',
  url: `${userManagementService}/api/admin/users/${userId}`,
  data: payload,
});

export const deleteUser = (userId) => http({
  method: 'delete',
  url: `${userManagementService}/api/admin/users/${userId}`,
});

export const disableUser = (userId) => http({
  method: 'post',
  url: `${userManagementService}/api/admin/users/${userId}/disable`,
});

export const resetUserPassword = (userId) => http({
  method: 'post',
  url: `${userManagementService}/api/admin/users/${userId}/reset-password`,
});

export const resendUserInvite = (userId) => http({
  method: 'post',
  url: `${userManagementService}/api/admin/users/${userId}/invite-again`,
});

export const activateUser = (userId) => http({
  method: 'post',
  url: `${userManagementService}/api/admin/users/${userId}/activate-manually`,
});
